// ═══════════════════════════════════════════════════════════════════════════
// ShippingPreview
// Extraído VERBATIM de index.html v0.9.16.
// ═══════════════════════════════════════════════════════════════════════════

import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { REMITENTE, fmt } from "../pdf/comunes.js";
import { generateShippingPDF } from "../pdf/envio.js";
import { LOGO_BASE64 } from "../pdf/logo.js";
import { btnPrimary, btnSecondary } from "./estilos.js";

export function ShippingPreview({ folio, client, lines, products, getPrice, totalBottles, notes, onClose }) {
  const fullBoxes = Math.floor(totalBottles / 12);
  const remaining = totalBottles % 12;
  const halfBoxes = Math.floor(remaining / 6);
  const looseBottles = remaining % 6;
  const totalBultos = fullBoxes + halfBoxes + (looseBottles > 0 ? 1 : 0);

  // Base value: cheapest tinto grossPrice
  const tintos = products.filter(p => p.category === "tinto" && p.grossPrice > 0);
  const basePrice = tintos.length > 0 ? Math.min(...tintos.map(p => p.grossPrice)) : products.filter(p => p.grossPrice > 0).reduce((m, p) => Math.min(m, p.grossPrice), Infinity);
  const fullBoxValue = Math.round(basePrice * 12 * 100) / 100;
  const halfBoxValue = Math.round(basePrice * 6 * 100) / 100;
  const looseValue = Math.round(basePrice * looseBottles * 100) / 100;
  const totalDeclared = fullBoxes * fullBoxValue + halfBoxes * halfBoxValue + looseValue;

  const teal = "#5ba8a8";
  const tealBg = "#e8f6f6";

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)", zIndex: 1000, display: "flex", alignItems: "flex-start", justifyContent: "center", overflow: "auto", padding: 20 }}
      onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: "#fff", color: "#111", maxWidth: 800, width: "100%", borderRadius: 8, padding: "40px 48px", marginTop: 20, fontFamily: "'DM Sans', sans-serif", fontSize: 12 }}>
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <img src={LOGO_BASE64} alt="Vinícola Total" style={{ width: 64, height: 64, objectFit: "contain" }} />
            <div>
              <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, margin: 0, color: teal }}>GUÍA DE ENVÍO</h1>
              <div style={{ fontSize: 11, color: "#888", marginTop: 4 }}>{new Date().toLocaleDateString("es-MX", { year: "numeric", month: "long", day: "numeric" })}</div>
            </div>
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 11, color: "#888" }}>FOLIO:</div>
            <div style={{ fontSize: 28, fontWeight: 700, color: teal }}>{folio}</div>
          </div>
        </div>

        {/* Addresses */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 32, marginBottom: 24, paddingBottom: 20, borderBottom: "2px solid #eee" }}>
          <div>
            <div style={{ fontSize: 10, color: teal, letterSpacing: 2, marginBottom: 6, fontWeight: 600 }}>REMITENTE</div>
            <div style={{ fontWeight: 600 }}>{REMITENTE.name}</div>
            <div>{REMITENTE.street}</div>
            <div>{REMITENTE.colonia}, CP {REMITENTE.cp}</div>
            <div>{REMITENTE.city}, {REMITENTE.state}</div>
            <div>Tel: {REMITENTE.whatsapp}</div>
          </div>
          <div>
            <div style={{ fontSize: 10, color: teal, letterSpacing: 2, marginBottom: 6, fontWeight: 600 }}>DESTINATARIO</div>
            <div style={{ fontWeight: 600 }}>{client.name}</div>
            {client.street && <div>{client.street}</div>}
            {(client.colonia || client.cp) && <div>{client.colonia}{client.colonia && client.cp ? ", " : ""}CP {client.cp}</div>}
            <div>{client.city}{client.state ? ", " + client.state : ""}</div>
            {client.att && <div style={{ fontWeight: 600, marginTop: 4 }}>Att: {client.att}</div>}
            {client.phone && <div>Tel: {client.phone}</div>}
          </div>
        </div>

        {/* Box Table */}
        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 20 }}>
          <thead>
            <tr style={{ borderBottom: "2px solid #ddd" }}>
              <th style={{ textAlign: "left", padding: "8px 4px", fontSize: 10, color: "#888" }}>DESCRIPCIÓN</th>
              <th style={{ textAlign: "center", padding: "8px 4px", fontSize: 10, color: "#888" }}>CANT.</th>
              <th style={{ textAlign: "center", padding: "8px 4px", fontSize: 10, color: "#888" }}>BOTELLAS</th>
              <th style={{ textAlign: "right", padding: "8px 4px", fontSize: 10, color: "#888" }}>VALOR DECLARADO</th>
            </tr>
          </thead>
          <tbody>
            {fullBoxes > 0 && (
              <tr style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: "8px 4px" }}>Caja completa (12 botellas)</td>
                <td style={{ textAlign: "center", padding: "8px 4px" }}>{fullBoxes}</td>
                <td style={{ textAlign: "center", padding: "8px 4px" }}>{fullBoxes * 12}</td>
                <td style={{ textAlign: "right", padding: "8px 4px" }}>{fmt(fullBoxes * fullBoxValue)}</td>
              </tr>
            )}
            {halfBoxes > 0 && (
              <tr style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: "8px 4px" }}>Media caja (6 botellas)</td>
                <td style={{ textAlign: "center", padding: "8px 4px" }}>{halfBoxes}</td>
                <td style={{ textAlign: "center", padding: "8px 4px" }}>{halfBoxes * 6}</td>
                <td style={{ textAlign: "right", padding: "8px 4px" }}>{fmt(halfBoxes * halfBoxValue)}</td>
              </tr>
            )}
            {looseBottles > 0 && (
              <tr style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: "8px 4px" }}>Botellas individuales</td>
                <td style={{ textAlign: "center", padding: "8px 4px" }}>{looseBottles}</td>
                <td style={{ textAlign: "center", padding: "8px 4px" }}>{looseBottles}</td>
                <td style={{ textAlign: "right", padding: "8px 4px" }}>{fmt(looseValue)}</td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Totals bar */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", background: tealBg, borderRadius: 8, marginBottom: 20, fontSize: 14, fontWeight: 700 }}>
          <div style={{ display: "flex", gap: 24 }}>
            <span>📦 Bultos: <span style={{ color: teal }}>{totalBultos}</span></span>
            <span>🍷 Botellas: <span style={{ color: teal }}>{totalBottles}</span></span>
          </div>
          <span>Valor declarado: <span style={{ color: teal }}>{fmt(totalDeclared)}</span></span>
        </div>

        {/* Handling instructions */}
        <div style={{ padding: "10px 16px", background: "#fff9e6", borderRadius: 8, border: "1px solid #f0e0a0", marginBottom: 20, fontSize: 12 }}>
          <strong>Contenido:</strong> Vino de mesa / Bebidas alcohólicas embotelladas<br />
          <strong>Manejo:</strong> FRÁGIL — No exponer al sol — Mantener en posición vertical
        </div>

        {/* Product detail */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 10, color: "#888", letterSpacing: 2, marginBottom: 8, fontWeight: 600 }}>DETALLE DE PRODUCTOS</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            {lines.map(li => {
              const prod = products.find(p => p.id === li.productId);
              return (
                <div key={li.productId} style={{ display: "flex", justifyContent: "space-between", padding: "4px 8px", background: "#fafafa", borderRadius: 4, fontSize: 12 }}>
                  <span>{prod?.name}</span>
                  <span style={{ fontWeight: 600 }}>× {li.qty}</span>
                </div>
              );
            })}
          </div>
        </div>

        {notes && (
          <div style={{ marginBottom: 20, padding: 12, background: "#fff9e6", borderRadius: 8, border: "1px solid #f0e0a0", fontSize: 12 }}>
            <strong>Notas:</strong> {notes}
          </div>
        )}

        <div style={{ marginTop: 24, display: "flex", flexWrap: "wrap", justifyContent: "flex-end", gap: 10 }}>
          <button onClick={onClose} style={{ ...btnSecondary, color: "#333", borderColor: "#ccc" }}>Cerrar</button>
          <button onClick={() => {
            const invData = { folio, client, lines: lines.map(li => {
              const prod = products.find(p => p.id === li.productId);
              const price = getPrice(li.productId);
              return { ...li, productName: prod?.name, unitPrice: price, amount: price * li.qty };
            }), totalBottles, notes, date: new Date().toISOString() };
            generateShippingPDF(invData, products);
          }} style={{ ...btnPrimary, display: "flex", alignItems: "center", gap: 6, background: "linear-gradient(135deg, #1a3a3a, #0d2a2a)", borderColor: "#2a5a5a" }}>
            📦 Descargar Guía PDF
          </button>
        </div>
      </div>
    </div>
  );
}
